import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import MaskedField from './MaskedField';

function CnpjField({ value, onChange, error, ...rest }) {
  const { t } = useTranslation()

  return (
    <MaskedField
      mask='99.999.999/9999-99'
      value={value}
      onChange={onChange}
      error={error}
      helperText={error ? t('default.cnpjFieldError') : ''}
      maskOptions={{
        alwaysShowMask: false,
        maskChar: ''
      }}
      {...rest}
    />
  )
}

CnpjField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
}

CnpjField.defaultProps = {
  value: '',
  onChange: () => true,
  error: false,
}

export default CnpjField